import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

const resetScrollableContainers = () => {
  const resetElement = (element) => {
    if (!element) return;
    element.scrollTop = 0;
    element.scrollLeft = 0;
  };

  window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  resetElement(document.scrollingElement);
  resetElement(document.documentElement);
  resetElement(document.body);

  document.querySelectorAll("*").forEach((element) => {
    const styles = window.getComputedStyle(element);
    const canScrollY =
      element.scrollHeight > element.clientHeight &&
      /(auto|scroll|overlay)/.test(styles.overflowY);
    const canScrollX =
      element.scrollWidth > element.clientWidth &&
      /(auto|scroll|overlay)/.test(styles.overflowX);

    if (canScrollY || canScrollX) {
      resetElement(element);
    }
  });
};

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    resetScrollableContainers();
    const frameId = window.requestAnimationFrame(resetScrollableContainers);

    return () => window.cancelAnimationFrame(frameId);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
